import { FC } from 'react';
import SearchForm from '../SearchForm';
import useSearchForm from './hooks/useSearchForm';
import { BaseSuperFormProps } from './interface';
import { FormProps } from 'antd/lib/form';

export interface DetailFormProps
  extends BaseSuperFormProps,
    Omit<FormProps, 'onReset'> {}
/** 详情页表单 */
export const DetailForm: FC<DetailFormProps> = props => {
  const {
    filterEmpty,
    formType,
    defaultLineNumber,
    defaultLabelCol,
    formItems,
    testId,
    actionRef,
    disabled,
    className,
    style,
    onFinish,
    ...resProps
  } = props;
  const renderChildren = useSearchForm(formItems, disabled);
  return (
    <SearchForm
      actionRef={actionRef}
      testId={testId}
      filterEmpty={filterEmpty}
      formType={formType}
      defaultLineNumber={defaultLineNumber}
      defaultLabelCol={defaultLabelCol}
      wrapperClassName={className}
      style={style}
      onFinish={onFinish}
      {...resProps}
    >
      {renderChildren}
    </SearchForm>
  );
};

DetailForm.defaultProps = {
  formType: 'detail',
};

export default DetailForm;
